import styled from "@emotion/styled";
import { IconButton } from "@mui/material";

export const SecretBoxWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const SecretBoxLabel = styled.div`
	font-size: 14px;
	line-height: 28px;
`;

export interface SecretBoxInputProps {
	width?: string;
	backgroundColor?: string;
}

export const SecretBoxInput = styled.div<SecretBoxInputProps>`
	border-radius: 4px;
	padding: 0 20px;
	width: 100%;
	display: flex;
	align-items: center;
	width: ${(props) => props.width || "100%"};
	background-color: ${(props) => props.backgroundColor || "#E8E8E8"};
`;

export interface SecretBoxValueProps {
	color?: string;
	height?: string;
}

export const SecretBoxValue = styled.p<SecretBoxValueProps>`
	width: 0;
	flex-grow: 1;
	color: ${(props) => props.color || "#000000"};
	line-height: ${(props) => props.height || "40px"};
	font-size: 14px;
`;

export const SecretBoxIconButton = styled(IconButton)`
	width: 30px;
	height: 30px;

	svg {
		height: 22px;
	}
`;

export const SecretBoxTooltip = styled.div`
	color: #888;
	font-size: 14px;
	line-height: 28px;
`;
